import { makeContext } from '@core/context/makeContext';

interface ChatContextValue {
  unreadChatMessagesCount?: number;
}

export const { Provider: ChatContextProvider, useContext: useChatContext } =
  makeContext<ChatContextValue>('ChatContext');
